let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kk84D")).then(() => parcelRequire('jpLx0'));